export enum Validator {
  isNotNull = "isNotNull",
}

export enum SelectionType {
  token = "token",
  sentence = "sentence",
  paragraph = "paragraph",
  custom = "custom",
  italics = "italics",
}

export enum WordSelectionMode {
  singleWord = "singleWord",
  multipleWords = "multipleWords",
  autoSplit = "autoSplit",
}

export const WordSelectionModeOptions = [
  { label: "Single Word", value: WordSelectionMode.singleWord },
  { label: "Multiple Words", value: WordSelectionMode.multipleWords },
  { label: "Auto Split", value: WordSelectionMode.autoSplit },
];

export enum SelfAssessmentStepType {
  baseMessage = "baseMessage",
  preCheck = "preCheck",
  guidedReview = "guidedReview",
  reminder = "reminder",
}

export const SelfAssessmentStepTypeOptions = [
  { label: "Base Message", value: SelfAssessmentStepType.baseMessage },
  { label: "Pre Check", value: SelfAssessmentStepType.preCheck },
  { label: "Guided Review", value: SelfAssessmentStepType.guidedReview },
  { label: "Reminder", value: SelfAssessmentStepType.reminder },
];

export enum AlternateHintType {
  paragraphDifferences = "paragraphDifferences",
  formattingDifferences = "formattingDifferences",
  placementDifferences = "placementDifferences",
  instanceCountDifferences = "instanceCountDifferences",
}

export const AlternateHintTypeOptions = [
  {
    label: "Paragraph Differences",
    value: AlternateHintType.paragraphDifferences,
  },
];

export type SelfAssessmentPlacement =
  | "bodyParagraphs"
  | "topicClinchers"
  | "lastSentence"
  | "title"
  | "introductionParagraph"
  | "conclusionParagraph";

export type SelfAssessmentStep = {
  id?: string;
  type: SelfAssessmentStepType;
  identifier: string;
  label: string;
  showInstancesWarning: boolean;
  hint?: string;
  alternateHint?: {
    type: AlternateHintType;
    hint: string;
  }[];
  selectionType: SelectionType;
  evaluationMethod: "document" | "paragraph" | "instance";
  isAssessing: boolean;
  assessmentResults?: boolean;
  errorMessage?: string;
  metricId?: string;
  numExpectedInstances?: number;
  autoComplete: boolean;
  errorMessageMap: {
    [key: string]: string;
  };
  criteriaAttribute: CriteriaAttribute;
  validationAttributes?: {
    [key: string]: (string | undefined)[] | boolean | undefined | Validator;
  };
  // Legacy configuration: used only when placementValidations is absent.
  placementValidation?: Exclude<SelfAssessmentPlacement, "title"> | "titleAndLastSentence";
  placementValidations?: SelfAssessmentPlacement[] | null;
  sentenceOpenerMarkerValidation?: string;
  duplicateAttributePrefix?: string;
  isHeader: boolean;
  isComplete: boolean;
  displayOrder: number;
  instructions?: any;
  instructionOverides?: {
    levelIds: string[];
    unitNumbers: string[];
    instructions: any;
    displayOrder: number;
  }[];
  checklistCriteria?: ChecklistCriteria;
  criteriaInstance?: CriteriaInstance;
  wordSelectionMode?: WordSelectionMode;
  showInstanceCount?: boolean;
  autoApplyInstances?: boolean;
  isPreCheckStep?: boolean;
  isBaseMessageStep?: boolean;
  rquireExactInstancesCount?: boolean;
};
